'use strict';

(function($) {

    var pluginName = 'kumsalLink';

    // plugin setup
    $.fn[pluginName] = function(options) {
        if ($(this).length === 0) {
            return;
        }

        // global variables
        var link = this;


        var Plugin = {
            isInit: false,
            sortable: null,
            options: {
                multiple: false,
                readonly: false,
                min: 0,
                max: 0,
                inputName: '',
            },
            maxLinkCondition: function(){
                return (!link.options.multiple && link.find('.kumsal-link').length) ||
                    (link.options.multiple && link.options.max && link.find('.kumsal-link').length >= link.options.max);
            },
            calculate:function(){
                link.maxLinkCondition() ?
                    link.find('.kumsal-link-create').addClass('d-none') :
                    link.find('.kumsal-link-create').removeClass('d-none');
                link.find('.kumsal-link-input').attr('name',link.options.inputName);
            },
            createLink:function(button){
                $(button).kumsalAction(Object.assign({}, $(button).data(),{
                    actionReady: function (action) {
                    },
                    actionSuccess: function (action,response) {
                        link.find('.kumsal-link-container').append(response.link);
                        link.calculate();
                        link.find('.kumsal-link-input').attr('name',link.options.inputName)
                    },
                    formData: {
                        translation:$(button).parents('.kumsal-links').data('translation'),
                        language:$(button).parents('.kumsal-links').data('language')
                    }
                }));
            },
            editLink:function(button){
                $(button).kumsalAction(Object.assign({}, $(button).data(),{
                    actionReady: function (action) {
                    },
                    actionSuccess: function (action,response) {
                        $(action).parents('.kumsal-link')[0].outerHTML = response.link;
                        link.calculate();
                    },
                    formData: {
                        translation:$(button).parents('.kumsal-links').data('translation'),
                        language:$(button).parents('.kumsal-links').data('language')
                    }
                }));
            },
            initEvents:function(){
                link.on('click','.kumsal-link-delete',function (event) {
                    event.preventDefault();
                    $(this).parents('.kumsal-link').remove();
                    link.calculate();
                });

                link.on('click','.kumsal-link-create',function (event) {
                    event.preventDefault();
                    if(!link.maxLinkCondition()){
                        link.createLink(this);
                    }
                });

                link.on('click','.kumsal-link-edit',function (event) {
                    event.preventDefault();
                    link.editLink(this);
                });
            },
            initSortable:function(){

                link.sortable = Sortable.create(link.find('.kumsal-link-container')[0], {
                    handle: '.kumsal-link-drag',
                    animation: 150,
                    group: 'links',
                    onEnd: function (e) {
                        $(e.item).parents('.kumsal-links').kumsalLink().calculate()
                    },
                });
            },
            init: function() {
                link.options = link.data();

                link.options.multiple = link.options.multiple || false;
                link.options.readonly = link.options.readonly || false;
                link.options.min = link.options.min || 0;
                link.options.max = link.options.max || 0;
                link.options.inpuName = link.options.inpuName || '';

                link.initEvents();

                if (link.options.multiple){
                    link.initSortable();
                }

                link.calculate();

                return link;
            },
        };

        /**
         * Public API methods can be used directly by datatable
         */
        $.each(Plugin, function(funcName, func) {
            link[funcName] = func;
        });


        if (!link.isInit){
            link.init();
        }

        return link;
    };

}(jQuery));

$('document').ready(function () {

    $(".kumsal-links").each(function( index ) {

        $(this).kumsalLink();
    });
});